import { render, staticRenderFns } from "./ViewActivityTypeRole.vue?vue&type=template&id=450a5f23"
import script from "./ViewActivityTypeRole.vue?vue&type=script&lang=js"
export * from "./ViewActivityTypeRole.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports